import { useTheme, Box, CardMedia } from '@mui/material';
import { ContentCard } from '../../components/ContentCard/ContentCard';
import { Copy } from '../../copy/Copy';
import { dynamicTextColor } from '../../helpers/dynamicTextColor';
import { ContactUsButton } from '../../components/ContactUsButton/ContactUsButton';

export const Discography = () => {
  const theme = useTheme();

  return (
    <>
      <Box>
        <ContentCard
          title={Copy.generate('Discography.title')}
          heading={Copy.inject('Discography.heading', {
            track: dynamicTextColor(
              'track by track.',
              theme.palette.quaternary.main,
            ),
          })}
          isColumn
          isTop
        />

        <ContentCard isSecondaryCard isColumn>
          <CardMedia
            component="iframe"
            title="Beats4MentalHealth"
            src="https://open.spotify.com/embed/playlist/7HYTjraCJke4yarLrrFBz1?utm_source=generator"
            width="100%"
            height={600}
            frameBorder="0"
            allowFullScreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            sx={{ borderRadius: '12px' }}
          />
        </ContentCard>

        <ContentCard
          heading={Copy.inject('Artists.contactUs.heading', {
            contact: dynamicTextColor(
              'contact us.',
              theme.palette.quaternary.main,
            ),
          })}
          isColumn
        >
          <ContactUsButton />
        </ContentCard>
      </Box>
    </>
  );
};
